// Module
var code = "<a ng-click=\"navigate()\" id=\"tab-inprogress-link-large-screen\" class=\"tab-inprogress-link waves-effect waves-blue mobile\"> <i class=\"{{item.icon}}\"></i>{{item.name}}<span class=\"badge\" ng-show=\"item.show()\">{{item.count()}}</span> </a> ";
// Exports
export default code;